import clsx from 'clsx'
import React from 'react'

interface ListProps extends Omit<React.HTMLAttributes<HTMLOListElement | HTMLUListElement>, 'className'> {
  children: React.ReactNode;
  type?: 'ordered' | 'unordered';
}

interface ListItemProps extends Omit<React.HTMLAttributes<HTMLLIElement>, 'className'> {
  children: React.ReactNode;
}

function Item ({ children, ...props }: ListItemProps) {
  return <li {...props} className='ml-5 mb-2 last:mb-0'>{children}</li>
}

export function List ({ children, type = 'unordered', ...props }: ListProps) {
  const Component = type === 'ordered' ? 'ol' : 'ul'

  const className = clsx('body text-gray-800 [li>&]:mt-2', {
    'list-decimal': type === 'ordered',
    'list-disc': type === 'unordered',
  })

  return (
    <Component {...props} className={className}>
      {children}
    </Component>
  )
}

List.Item = Item
